import {GameVariant, Nullable} from "../caos-def";
import {bitmaskToVariantArray, gameName, SetVariantFunc} from "../utils.variants";
import {MouseEvent} from "react";


type VariantsListProp = {
    variants: GameVariant[]|number;
    setVariant: SetVariantFunc;
    useSeaMonkeys: boolean;
}


/**
 * Display of variants, highlighting variants this command or values list applies to.
 * @param variants
 * @param setVariant
 * @param useSeaMonkeys
 * @constructor
 */
export default function VariantsList({variants, setVariant, useSeaMonkeys}: VariantsListProp) {

    /**
     * Applies the variant that is clicked to the entire guide
     * @param event
     */
    function onVariantClick(event: MouseEvent) {
        event.preventDefault();
        const variant = (event.target as HTMLElement)
            .closest("[data-for-variant]")
            ?.getAttribute("data-for-variant") as Nullable<GameVariant>;
        setVariant(variant, true);
    }

    /**
     * Gets an item representing a given variant
     * @param variant
     */
    function variantItem(variant: GameVariant) {
        return <div className="variant-check-mark"
             data-for-variant={variant.toLowerCase()}
             aria-hidden="true"
             onClick={onVariantClick}
        ><span>{variant}</span></div>
    }

    // All game names used this command or values lists applies to.
    // Used in screen reader;
    // TODO see if this is too annoying
    if (typeof variants === "number") {
        variants = bitmaskToVariantArray(variants);
    }
    const names = (variants as GameVariant[])
        .filter((variant:GameVariant) => useSeaMonkeys || variant !== 'SM')
        .map((variant:GameVariant) => gameName(variant)).join(",");

    // Returns the JSX variants bar
    return <div className="text-align-right variants-container">
        <p className="screen-reader-only">Variants:{names}</p>
        <div className="variant-header">
            {variantItem("C1")}
            {variantItem("C2")}
            {variantItem("CV")}
            {variantItem("C3")}
            {variantItem("DS")}
            { useSeaMonkeys ? variantItem("SM") : ""}
        </div>
    </div>
}